module.exports = __webpack_public_path__ + "static/media/kitchen-re-fit_02.f1dd7a66.png";